<template lang="pug">
  div.col-12(v-if="currentUser.rights.simCallsBases == true")
    .content-wrapper
      h2.m-0 Телефонные базы обзвона
      button.btn.btn-info.col-2(v-on:click='createBase' v-if="currentUser.rights.simCallsBasesEdit") Добавить базу контактов
      table.table.table-hover
        thead
          tr
            th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
        tbody
          tr(v-for="row in baseList" v-bind:key="row.id")
            td(v-for="td in columnsHeader" v-bind:key="td.id") {{ row[td.key] }}
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.simCallsBasesEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startBase(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopBase(row.id)')
                i.far.fa-pen.mr-2(v-on:click='showModal(row.id)')
                i.far.fa-upload.mr-2(v-on:click='addContacts(row.id)')
                i.far.fa-trash.mr-2(v-on:click='deleteBase(row.id)')
              span.td-actions(v-if="td.key === 'actions' && !currentUser.rights.simCallsBasesEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startBase(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopBase(row.id)')
    modal(v-show="isModalVisible" v-on:close="closeModal")
      template(v-slot:header="")
        div.d-block.col-12
          h2 {{ modalData.base.name }}
          .form-group
            button.btn.btn-info.col-2(v-on:click="saveBase") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body="")
        div
          fieldset
            .form-group.col-12
              label Название
              input.form-control(v-model='modalData.base.name' type='text' placeholder='Введите название базы контактов' required='')
            .form-group.col-12
              label Проект
              select.form-control(v-model='modalData.base.project_id')
                option(v-for='(pr, pr_index) in projects' v-bind:key='pr_index' v-bind:value='pr.id') {{ pr.name }}
            .form-group.col-12
              label Пауза для повторного звонка
              input.form-control(v-model='modalData.base.timeout' type='text' placeholder='Введите название базы контактов' required='')
            .form-group.col-12
              label Количество попыток
              input.form-control(v-model='modalData.base.retry' type='text' placeholder='Введите название базы контактов' required='')
            .form-group.col-12(v-if='modalData.base.id > 0')
              button.btn.btn-info(v-on:click="addContacts") Загрузить контакты
      template(v-slot:footer="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal") Закрыть
    modal2(v-show="isModalVisible2" v-on:close="closeModal2")
      template(v-slot:header2="")
        div.d-block.col-12
          h2 {{ modalData.base.name }}
      template(v-slot:body2="")
        div(v-if="baseIsSending")
          h3.text-center Контакты отправляются на удалённый сервер...
          h5.text-center Это может занять несколько минут
        div(v-else)
          fieldset
            .form-group.col-12
              label Выберите загруженную базу контактов для отправки на сервер
              select.form-control(v-model='localBase')
                option(v-for='(pr, pr_index) in localBases' v-bind:key='pr_index' v-bind:value='pr.id') {{ pr.name }}
            .form-group.col-12
              button.btn.btn-info(v-on:click="uploadContacts") Загрузить
      template(v-slot:footer2="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal2") Закрыть
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  data () {
    var columnsHeader = [
      {title: 'ID базы', key: 'id'},
      {title: 'Проект', key: 'project_name'},
      {title: 'Название', key: 'name'},
      {title: 'Активная', key: 'state'},
      {title: 'Пповтор через ', key: 'timeout'},
      {title: 'Кол-во попыток', key: 'retry'},
      {title: 'Загружено контактов', key: 'contacts'},
      {title: 'Действия', key: 'actions'}
    ]
    // const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      sortKey: '',
      isModalVisible: false,
      isModalVisible2: false,
      modalData: {},
      emptyModalData: null,
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      openBase: 0,
      localBase: 0,
      baseIsSending: false,
      bases: [],
      localBases: [],
      projects: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    baseList: function () {
      let list = []
      this.bases.forEach((item) => {
        item.actions = ''
        item.state = item.is_active ? 'Активна' : 'Остановлена'
        item.project_name = this.getProjectName(item.project_id)
        list.push(item)
      })
      if (this.sortKey) {
        let order = this.sortOrders[this.sortKey] || 1
        list = list.sort((a, b) => {
          let x = a[this.sortKey]
          let y = b[this.sortKey]
          if (typeof x == 'string') {
            x = x.toLowerCase()
            y = y.toLowerCase()
          }
          return (x === y ? 0 : x > y ? 1 : -1) * order
        })
      }
      return list
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (baseId = 0) {
      this.openBase = baseId
      if (baseId < 1) {
        this.resetModalData()
        this.isModalVisible = true
        return true
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/get.php&id=' + baseId)
        .then(response => {
          this.isModalVisible = true
          this.modalData.base = response.data.base
        })
    },
    closeModal () {
      this.openBase = 0
      this.isModalVisible = false
    },
    resetModalData () {
      this.emptyModalData = {}
      this.modalData.base = {id: 0, name: "Новая база", project_id: 0, is_active: 1, timeout: 60, retry: 3}
      this.emptyModalData.base = {id: 0, name: "Новая база", project_id: 0, is_active: 1, timeout: 60, retry: 3}
    },
    showModal2 () {
      this.isModalVisible2 = true
    },
    closeModal2 () {
      this.isModalVisible2 = false
    },
    getBaseList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/get.php')
        .then(response => {
          // let data = JSON.parse(response.data)
          let data = response.data
          this.bases = data.list
        })
    },
    createBase () {
      this.showModal()
    },
    addContacts (baseId = 0) {
      if (baseId < 1) {
        this.showModal2()
      }
      this.openBase = baseId
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/get.php&id=' + baseId)
        .then(response => {
          this.modalData.base = response.data.base
          this.showModal2()
        })
    },
    uploadContacts () {
      this.baseIsSending = true
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=sendContactsToSimCalls&base_id=' + this.localBase + '&sim_base_id=' + this.modalData.base.id)
        .then(response => {
          this.baseIsSending = false
          this.getBaseList()
          this.closeModal2()
          this.closeModal()
        })
    },
    saveBase () {
      let p = {}
      p.base = JSON.stringify(this.modalData.base)
      if (this.modalData.base.id > 0) {
        p.url = '/api/base/update.php'
      } else {
        p.url = '/api/base/add.php'
      }
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/simCalls.php', p)
        .then(() => { this.getBaseList() })
      this.closeModal()
    },
    startBase (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/update.php&is_active=1&id=' + id)
        .then(response => {
          this.getBaseList()
        })
    },
    stopBase (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/update.php&is_active=0&id=' + id)
        .then(response => {
          this.getBaseList()
        })
    },
    deleteBase (id) {
      if (!confirm('Подтвердите удаление базы')) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/base/delete.php&id=' + id)
        .then(response => {
          this.getBaseList()
        })
    },
    getProjectList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/get.php')
        .then(response => {
          this.projects = response.data.list
        })
    },
    getProjectName (id) {
      let p = this.projects.find(item => item.id == id)
      return p ? p.name : ''
    },
    getLocalBaseList () {
      this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getBasesList&client_id=' + this.client_id)
        .then(response => (this.localBases = response.data.bases))
    }
  },
  mounted () {
    this.resetModalData()
    this.getProjectList()
    this.getBaseList()
    this.getLocalBaseList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/simCalls/bases.vue